import { useCallback } from 'react';

import { useUser } from '@/entities/user/model/user.store';

import { useFeatures } from './use-features';
import { useWs } from './use-ws';
import { MessageAction, MessageType } from './use-ws/types';

interface ObfuscatedEvent {
  type: string;
  name: string;
  properties: {
    blink: number;
    kcv: number;
    user_id: number;
  };
}

const generateRandomString = (length: number = 5): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from({ length }, () =>
    chars.charAt(Math.floor(Math.random() * chars.length))
  ).join('');
};

const calculateDateSum = (date: Date): number => {
  return date
    .getUTCFullYear()
    .toString()
    .concat(
      (date.getUTCMonth() + 1).toString().padStart(2, '0'),
      date.getUTCDate().toString().padStart(2, '0')
    )
    .split('')
    .reduce((sum, digit) => sum + parseInt(digit), 0);
};

export const useObfuscatedAdEvents = () => {
  const user = useUser();
  const { sendMessage } = useWs();

  const features = useFeatures();

  const sendObfuscatedEvents = useCallback(() => {
    if (features.STOP_OBFUSCATING_EVENTS) return;

    const now = Date.now();
    const userId = user?.telegramId ?? 0;

    // Создаем объект Date для текущей UTC даты в полночь
    const dateForThirdEvent = new Date(now);
    dateForThirdEvent.setUTCHours(0, 0, 0, 0);

    const events: ObfuscatedEvent[] = [
      {
        type: generateRandomString(),
        name: generateRandomString(),
        properties: {
          blink: now - 60000,
          kcv: Math.floor(Math.random() * 10),
          user_id: userId,
        },
      },
      {
        type: generateRandomString(),
        name: generateRandomString(),
        properties: {
          blink: now + 60000,
          kcv: Math.floor(Math.random() * 10),
          user_id: userId,
        },
      },
      {
        type: generateRandomString(),
        name: generateRandomString(),
        properties: {
          blink: dateForThirdEvent.getTime(),
          kcv: calculateDateSum(dateForThirdEvent),
          user_id: userId,
        },
      },
    ].sort(() => Math.random() - 0.5);

    events.forEach((event) => {
      sendMessage(MessageType.ANALYTICS, MessageAction.EXECUTE, {
        type: event.type,
        created: Date.now(),
        user_properties: {
          telegram_id: userId,
        },
        event_properties: {
          name: event.name,
          blink: event.properties.blink,
          kcv: event.properties.kcv,
          game_key: null,
        },
      });
    });
  }, [sendMessage, user]);

  return { sendObfuscatedEvents };
};
